import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Select2Multiple from 'v-select2-multiple-component';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import axios from "axios";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import Loading from 'vue-loading-overlay';
import CONFIG from "@/assets/js/config.js";
import SelectAllService from '@/services/SelectAllService';
import HandlePaginateService from "@/services/HandlePaginateService";
import store from "@/store";

export default {
  name: "attendanceTeacherList",
  components: {
    MainLayout,
    flatPickr,
    Select2Multiple,
    AdvancedLaravelVuePaginate,
    Loading,
  },

  mixins: [SelectAllService],

  data() {
    return {
      searchData: {},
      initialStartDate: '',
      initialEndDate: '',
      attendanceList: {},
      paginationData: {},
      noDataMsg: CONFIG.NO_DATA_FOUND,
      CONFIG,
      isFilterOpen: false,
      isLoading: false,
      search_status: false,
      role: store.state.user.role,
    };
  },

  computed: {
    isHrOperator() {
      const role = Number(this.$store.state.user?.role);
      return role === CONFIG.ROLE.ID.HR_OPERATOR || role === CONFIG.ROLE.ID.SUPER_ADMIN;
    },
    attendanceApiBase() {
      return this.isHrOperator ? 'hr/employee-attendance' : 'employee-attendance';
    },
  },

  methods: {
    buildFilterParams(page = null) {
      const params = {
        ...this.searchData,
        start_date: this.searchData.start_date || this.initialStartDate,
        end_date: this.searchData.end_date || this.initialEndDate,
      };

      if (page !== null && page !== undefined) {
        params.page = page;
      } else {
        delete params.page;
      }

      return params;
    },

    getAttendanceList(page = 1) {
      this.isLoading = true;

      var request = {
        params: this.buildFilterParams(page),
      }

      axios.get(`/${this.attendanceApiBase}/attendanceList`, request)
        .then(response => {
          if (page > 1 && !response.data.data.length) {
            this.getAttendanceList(page - 1);
            return;
          }

          this.getAttendanceData(response);
          this.isLoading = false;
        })
        .catch(error => {
          this.isLoading = false;
          if (error.response?.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          if (error.response?.status === 422) {
          const errors = error.response.data.errors;
          const firstError = errors ? Object.values(errors)[0][0] : error.response.data.message;

          this.$notification.error(firstError, {
            timer: 3,
            position: "bottomCenter"
          });
          return;
        }
          console.log("Attendance List API Error", error);
        });
    },

    search(page = 1) {
      this.isLoading = true;
      this.search_status = true;
      var request = {
        params: this.buildFilterParams(page),
      }
        
      axios.get(`/${this.attendanceApiBase}/attendanceList`, request)
        .then(response => {
          this.search_status = true;

          if (page > 1 && !response.data.data.length) {
            this.search(page - 1);
            return;
          }

          this.getAttendanceData(response);
          this.isLoading = false;
        })
        .catch(error => {
          if (error.response?.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          console.log("Employee Attendance Search API Error", error);
          this.isLoading = false;
        });
    },

    filter() {
      this.resetSelectedAll();
      this.search_status = true;
      this.search();
    },

    getAttendanceData(res) {
        this.paginationData = res.data;
        this.currentCbs = [];
        this.attendanceList = res.data.data.map((att) => {
          this.storeCurretCbs(att.id);
          return {
            id: att.id,
            date: `${att.date} (${att.dayname})`,
            employee_name: att.employee_name || att.teacher_name,
            employee_no: att.employee_no,
            employeeable_type_text: att.employeeable_type_text,
            teacher_name: att.employee_name || att.teacher_name,
            checkTimes: Object.entries(att)
                              .filter(([key]) => key.includes("actual_"))
                              .map(([,value]) => value),
          }
        });
    },

    reset() {
      this.searchData = {};
      this.search_status = false;
      this.setInitialDateRange();
      this.resetSelectedAll();
      this.getAttendanceList();
    },

    clear() {
      this.requestDelete(
        "patch",
        `/${this.attendanceApiBase}/clear`,
        'Attendance deleted successfully', 
        "Attendance deleted api Error"
      );
    },

    del() {
      this.requestDelete(
        "post", 
        `/${this.attendanceApiBase}/deleteShiftAssigns`,
        'Attendance Shift Assigns deleted successfully', 
        "Attendance Shift Assigns deleted api Error"
      );
    },

    showCreate() {
      this.$router.push({
        name: "attendanceTeacherCreate"
      });
    },

    requestDelete(method, api, successMessage, errorMessage) {
      if (this.isEmptySelected(this.paginationData.total)) {
        this.$notification.error('Select at least one attendance', {
          timer: 3,
          position: "bottomCenter"
        });
        return;
      }

      if (!window.confirm("Are you sure you want to delete?")) {
        return;
      }

      const selectedAll = this.selectedAllToggle;
      const attendanceIds = [...this.selectedIds];
      const searchParams = this.buildFilterParams();

      this.isLoading = true;
      axios[method](api, {
        attendance_ids: attendanceIds,
        selected_all: selectedAll,
        search: searchParams,
      })
      .then(() => {
        this.resetSelectedAll();
        if (this.search_status) {
          this.search(this.paginationData.current_page);
        } else {
          this.getAttendanceList(this.paginationData.current_page);
        }
        this.$notification.success(successMessage, {
          timer: 3,
          position: "bottomCenter"
        });
      })
      .catch(error => {
        this.isLoading = false;
        if (error.response?.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
          return;
        }
        if (error.response?.status === 422) {
          const errors = error.response.data.errors;
          const firstError = errors
            ? Object.values(errors)[0][0]
            : error.response.data.message;
          this.$notification.error(firstError || errorMessage, {
            timer: 3,
            position: "bottomCenter"
          });
          return;
        }
        this.$notification.error(errorMessage, {
          timer: 3,
          position: "bottomCenter"
        });
        console.log(errorMessage, error);
      });
    },

    setInitialDateRange() {
      const formatDate = (date) => {
        const y = date.getFullYear();
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const d = String(date.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
      };

      const now = new Date();
      this.initialStartDate = formatDate(new Date(now.getFullYear(), now.getMonth(), 1));
      this.initialEndDate = formatDate(new Date(now.getFullYear(), now.getMonth() + 1, 0));
      this.searchData.start_date = this.initialStartDate;
      this.searchData.end_date = this.initialEndDate;
    },

    handlePaginate(page) {
      HandlePaginateService.paginate({
        page,
        isSearch: this.search_status,
        searchFn: this.search,
        listFn: this.getAttendanceList
      })
    },
  },

  mounted() {
    this.isLoading = true;
    this.setInitialDateRange();
    this.getAttendanceList();
  },
};
